import { ChangeDetectorRef, Component, inject, Input, input, viewChild, ViewChild } from '@angular/core';
import { User } from '../../models/user';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material.module';
import { UserService } from '../../services/user.service';
import { MatMenu } from '@angular/material/menu';
import { ThumbnailPipe } from '../../shared/pipes/thumbnail.pipe';

@Component({
  selector: 'app-chat-user',
  standalone: true,
  templateUrl: './chat-user.component.html',
  styleUrl: './chat-user.component.scss',
  imports: [
    CommonModule,
    MaterialModule,
    ThumbnailPipe,
  ]
})
export class ChatUserComponent {
  public user = input<User>();

  @Input() showMenu = false;
  @Input() isAgent = false;
  @Input() text;

  public currentUser = null;

  public userData = null;

  public defaultPicture = 'assets/images/kogu.background.png';

  users: User[] = [];

  userMenu = viewChild<MatMenu>('userMenu');

  private userService = inject(UserService);

  private cdr = inject(ChangeDetectorRef);

  constructor() {
    this.userService.user$.subscribe((user) => {
      this.currentUser = user;
    })
    this.userService.users$.subscribe((users) => {
      this.cdr.markForCheck();
      this.users = users;
      this.setUser();
    })
  }
  ngOnInit(): void {
    this.setUser();
  }
  setUser() {
    if(!this.user()) return;
    this.userData = this.users.find((user) => user.id === this.user().id);
    if (!this.userData) {
      this.userData = {...this.user()};
    }
  }
  getInitials(name): string {
    if (!name) return this.text || '??';
    return name.split(' ').map(part => part.charAt(0)).join('').toUpperCase();
  }
  setOnline(value){
    this.userService.setOnlineStatus(value).subscribe((response) => {
      this.user().online = value;
    })
  }
}
